module.exports = __webpack_public_path__ + "static/media/higg-index-logo.8eadb789.png";